module.exports = __webpack_public_path__ + "media/images/map-icons/icons/station-plu-icon-622fb499a4546e6993e8a5436f8c8943.png";